import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { PlatformService } from '@core/services/platform.service';
import { CommonService } from '@modules/shared/services/common.service';

/**
 * Blocks TopFans marketing surfaces on tenant sites and sends visitors home.
 * During prerender, allow the route so Angular writes a real HTML shell for `/`
 * instead of a meta-refresh redirect stub (same pattern as whitelabel.guard).
 */
export const whitelabelV2Guard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  const cs = inject(CommonService);
  const platformService = inject(PlatformService);

  if (platformService.isPrerendered) {
    return true;
  }

  if (authService.isWhiteLabelWebsite()) {
    cs.navigateToWhiteLabelHome();
    return false;
  }
  return true;
};
